module.exports = __webpack_public_path__ + "assets/img/ic-shoe.d1415107.svg";